import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { ResponsiveImage } from '../../components';
import WorkItemCard from '../../components/WorkItemCard';

import css from './ProfilePage.module.css';

const SectionPastWorks = ({ pastWorks, title }) => {
  const [viewMode, setViewMode] = useState('detailed'); // 'card' or 'detailed'
  // Handle different data formats
  let worksArray = [];

  if (Array.isArray(pastWorks)) {
    worksArray = pastWorks;
  } else if (typeof pastWorks === 'string') {
    try {
      worksArray = JSON.parse(pastWorks);
    } catch (e) {
      console.error('Failed to parse pastWorks:', e);
      return null;
    }
  } else if (pastWorks && typeof pastWorks === 'object') {
    // If it's already an object, try to use it
    worksArray = [pastWorks];
  }

  if (!worksArray || worksArray.length === 0) {
    return null;
  }

  return (
    <div className={css.sectionPastWorks}>
      <div className={css.pastWorksHeader}>
        <h3 className={css.customFieldTitle}>
          {title || <FormattedMessage id="ProfilePage.pastWorksTitle" />}
        </h3>
        <div className={css.viewToggle}>
          <button
            className={`${css.viewToggleButton} ${viewMode === 'card' ? css.active : ''}`}
            onClick={() => setViewMode('card')}
            aria-label="Card view"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="3" width="7" height="7" rx="1" />
              <rect x="14" y="3" width="7" height="7" rx="1" />
              <rect x="3" y="14" width="7" height="7" rx="1" />
              <rect x="14" y="14" width="7" height="7" rx="1" />
            </svg>
          </button>
          <button
            className={`${css.viewToggleButton} ${viewMode === 'detailed' ? css.active : ''}`}
            onClick={() => setViewMode('detailed')}
            aria-label="Detailed view"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="4" width="18" height="5" rx="1" />
              <rect x="3" y="12" width="18" height="5" rx="1" />
            </svg>
          </button>
        </div>
      </div>
      <div className={viewMode === 'card' ? css.pastWorksGrid : css.pastWorksDetailedList}>
        {worksArray.map((work, index) => (
          <WorkItemCard
            key={index}
            title={work.title}
            description={work.description}
            imageUrl={work.image}
            url={work.url}
            metadata={work.metadata}
            viewMode={viewMode === 'detailed' ? 'detailed' : 'card'}
            className={viewMode === 'card' ? css.pastWorkCard : css.pastWorkDetailedItem}
          />
        ))}
      </div>
    </div>
  );
};

export default SectionPastWorks;